window.addEventListener('DOMContentLoaded', (event) => {
  const pages = document.getElementsByClassName('thanks-page')
  if (pages.length == 0) return;

  /////// サンクスメッセージの展開表示
  const thanksMessage = document.getElementsByClassName('thanks-message')[0]
  const messageWrapper = document.getElementsByClassName('message-wrapper')[0]
  const messageObjects = document.querySelectorAll('[data-ellipsis]')
  const seeMore = document.getElementById('see-more')

  if (messageWrapper != undefined) {
    const messageWrapperClone = messageWrapper.cloneNode(true)
    const messagesArray = [].slice.call(messageObjects)

    reduceScrollHeight() <= messageWrapper.offsetHeight ? seeMore.remove() : ellipsisMessage()

    seeMore.addEventListener('click', (e) => {
      thanksMessage.replaceChild(messageWrapperClone, messageWrapper)
      messageWrapperClone.style.height = 'auto'
      seeMore.remove()
    })

    function reduceScrollHeight() {
      return messagesArray.reduce((totalScrollHeight, object) => {
        return totalScrollHeight + object.scrollHeight
      }, 0)
    }

    function ellipsisMessage() {
      messagesArray.reverse().forEach(messageObject => {
        const reducedScrollHeight = reduceScrollHeight()
        const fixedScrollHeight = reducedScrollHeight - messageObject.scrollHeight

        if (fixedScrollHeight + messageObject.scrollHeight > messageWrapper.offsetHeight) {
          const nextLineOffset = 14; // 表示可能行の次行の途中まで表示するためのオフセット
          messageObject.style.height = (messageWrapper.offsetHeight + nextLineOffset) + 'px'
        }
      });
    }
  }

  /////// Eightアプリのインストール訴求バナー
  const bannerHeader = document.querySelector('.banner-header');
  const bannerContents = document.querySelector('.banner-contents');
  bannerHeader.addEventListener('click', () => {
    if (bannerHeader.classList.contains('open')) {
      bannerHeader.classList.remove('open');
      bannerHeader.classList.add('close');
      bannerContents.classList.remove('open');
      bannerContents.classList.add('close');
    } else {
      bannerHeader.classList.remove('close');
      bannerHeader.classList.add('open');
      bannerContents.classList.remove('close');
      bannerContents.classList.add('open');
    }
  });
})
